import styled from "styled-components";
import FilterButtons from "Components/Fragment/FilterButtons";

export const StyledFilterButtons = styled(FilterButtons)`
  margin-left: 24px;
`;

export const StyledProgram = styled.div`
  padding: 0 0 48px 0;
  max-width: 1100px;

  .card-course-icon {
    position: absolute;
    top: 5px;
    left: 5px;
  }

  .card-dates span {
    font-size: 14px;
  }

  .managerSelect__menu {
    z-index: 10 !important;
  }

  div.MuiCardMedia-root,
  img {
    width: 100%;
    aspect-ratio: 16/9;
    height: auto;
    scale: 0.9;
    margin-top: 3px;
  }
`;

export const StyledSurveyLinkContainer = styled.div`
  margin-top: 25px;
`;

export const STYLE_PROGRAM_HEADER = {
  margin: "0 0 10px 0",
  "& img": {
    width: "100%",
    maxWidth: 450,
    aspectRatio: "16/9",
    objectFit: "contain",
    "@media (min-width: 700px)": {
      minWidth: 450,
    },
  },
  "& .header-info": {
    padding: "10px",
  },
  "& .program-description-text": {
    "@media (min-width: 700px)": {
      maxWidth: 550,
    },
  },
  "& .program-header-wrapper": {
    "@media (max-width: 700px)": {
      flexDirection: "column",
    },
  },
};

export const STYLE_CARD_HEADING = {
  fontWeight: "normal",
  fontSize: "inherit",
};
